import React, {PropTypes} from 'react';
import ReactDOM from 'react-dom';
import BaseToggle from './base-toggle';
import {Checkmark, CheckmarkIndeterminate} from 'cap-it-ui.icons';

import '../styles/checkbox.scss';

function setIndeterminateState(selectedState, indeterminateState) {
    indeterminateState = selectedState ? indeterminateState : false; // eslint-disable-line no-param-reassign
    ReactDOM.findDOMNode(this).querySelector('input').indeterminate = indeterminateState;
}

function getModalClasses() {
    const classes = ['checkbox-inline'];

    if (this.props.indeterminate) {
        classes.push('indeterminate');
    }

    return classes.join(' ');
}

function checkboxChangeHandler(value, event) {
    if (this.props.indeterminate && this.props.selected) {
        this.props.onChange(value, this.props.selected, event);
    } else {
        this.props.onChange(value, !this.props.selected, event);
    }
}

class Checkbox extends React.Component {
    static displayName = 'Checkbox';

    static propTypes = {
        children: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        id: PropTypes.string.isRequired,
        indeterminate: PropTypes.bool,
        name: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        selected: PropTypes.bool.isRequired
    };

    static defaultProps = {
        indeterminate: false
    };

    componentDidMount() {
        setIndeterminateState.call(this, this.props.selected, this.props.indeterminate);
    }

    componentDidUpdate() {
        setIndeterminateState.call(this, this.props.selected, this.props.indeterminate);
    }

    render() {
        const {
            children,
            disabled,
            id,
            indeterminate,
            name,
            selected
        } = this.props;
        const modalClass = getModalClasses.call(this);
        const icon = indeterminate ? (<CheckmarkIndeterminate/>) : (<Checkmark/>);

        return (
            <BaseToggle
                className={modalClass}
                disabled={disabled}
                icon={icon}
                id={id}
                name={name}
                onChange={checkboxChangeHandler.bind(this)}
                selected={selected}
                type='checkbox'
            >
                {children}
            </BaseToggle>
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/src/checkbox.js